import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { authApi } from "@/api/auth";
import { ApiError } from "@/api/client";
import { AuthShell } from "@/components/AuthShell";

export function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const [state, setState] = useState<"idle" | "verifying" | "done" | "error">("idle");
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setState("error");
      setMessage("Missing verification token.");
      return;
    }
    setState("verifying");
    authApi
      .verifyEmail(token)
      .then(() => setState("done"))
      .catch((err) => {
        setState("error");
        setMessage(err instanceof ApiError ? err.message : "Verification failed.");
      });
  }, [token]);

  return (
    <AuthShell subtitle="Email verification">
      {state === "verifying" && <p className="text-center text-sm text-ef-textDim">Verifying…</p>}
      {state === "done" && (
        <div className="rounded-[var(--radius-sm)] border border-ef-ok/20 bg-ef-ok/10 px-3 py-2.5 text-sm text-ef-ok">
          Email verified! You can close this tab.
        </div>
      )}
      {state === "error" && (
        <div className="rounded-[var(--radius-sm)] border border-ef-err/20 bg-ef-err/[0.08] px-3 py-2.5 text-sm text-ef-err">
          {message}
        </div>
      )}
      <p className="mt-3 text-center text-xs text-ef-textMuted">
        <Link className="inline-flex min-h-9 items-center text-ef-accent hover:underline" to="/login">
          Back to sign in
        </Link>
      </p>
    </AuthShell>
  );
}
